(function () {
  const productTitleMap = {
    flight_safe_battery: {
      aliases: [
        'Strutt ev¹ Flight-safe Battery',
        'Strutt ev1 Flight-safe Battery',
        'Flight-safe Battery',
        'Flight Safe Battery'
      ],
      titles: {
        en: 'Strutt ev¹ Flight-safe Battery',
        de: 'Strutt ev¹ flugsicherer Akku',
        fr: 'Batterie Strutt ev¹ homologuée pour le transport aérien',
        it: 'Batteria Strutt ev¹ idonea al trasporto aereo',
        nl: 'Strutt ev¹ vliegveilige batterij',
        es: 'Batería Strutt ev¹ apta para transporte aéreo',
        'zh-CN': 'Strutt ev¹ 航空安全电池',
        'zh-TW': 'Strutt ev¹ 航空安全電池',
        ja: 'Strutt ev¹ 航空機内持ち込み対応バッテリー',
        ko: 'Strutt ev¹ 항공 안전 배터리',
        th: 'แบตเตอรี่ Strutt ev¹ สำหรับการเดินทางทางอากาศ'
      }
    },
    long_range_battery: {
      aliases: [
        'Strutt ev¹ Long-range Battery',
        'Strutt ev1 Long-range Battery',
        'Long-range Battery',
        'Long Range Battery'
      ],
      titles: {
        en: 'Strutt ev¹ Long-range Battery',
        de: 'Strutt ev¹ Langstrecken-Akku',
        fr: 'Batterie longue autonomie Strutt ev¹',
        it: 'Batteria a lunga autonomia Strutt ev¹',
        nl: 'Strutt ev¹ batterij met groot bereik',
        es: 'Batería de larga autonomía Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 长续航电池',
        'zh-TW': 'Strutt ev¹ 長續航電池',
        ja: 'Strutt ev¹ ロングレンジバッテリー',
        ko: 'Strutt ev¹ 장거리 배터리',
        th: 'แบตเตอรี่ระยะไกล Strutt ev¹'
      }
    },
    fast_charger: {
      aliases: [
        'Strutt ev¹ Fast Charger',
        'Strutt ev1 Fast Charger',
        'Fast Charger'
      ],
      titles: {
        en: 'Strutt ev¹ Fast Charger',
        de: 'Strutt ev¹ Schnellladegerät',
        fr: 'Chargeur rapide Strutt ev¹',
        it: 'Caricatore rapido Strutt ev¹',
        nl: 'Strutt ev¹ snellader',
        es: 'Cargador rápido Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 快速充电器',
        'zh-TW': 'Strutt ev¹ 快速充電器',
        ja: 'Strutt ev¹ 急速充電器',
        ko: 'Strutt ev¹ 고속 충전기',
        th: 'เครื่องชาร์จเร็ว Strutt ev¹'
      }
    },
    seat_storage: {
      aliases: [
        'Strutt ev¹ Seat Storage',
        'Strutt ev1 Seat Storage',
        'Seat Storage'
      ],
      titles: {
        en: 'Strutt ev¹ Seat Storage',
        de: 'Strutt ev¹ Sitzaufbewahrung',
        fr: 'Rangement de siège Strutt ev¹',
        it: 'Contenitore sedile Strutt ev¹',
        nl: 'Strutt ev¹ stoelopbergruimte',
        es: 'Almacenamiento de asiento Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 座椅收纳包',
        'zh-TW': 'Strutt ev¹ 座椅收納包',
        ja: 'Strutt ev¹ シートストレージ',
        ko: 'Strutt ev¹ 시트 수납함',
        th: 'ที่เก็บของใต้เบาะ Strutt ev¹'
      }
    },
    phone_cup_mount: {
      aliases: [
        'Strutt ev¹ Phone & Cup Mount',
        'Strutt ev1 Phone & Cup Mount',
        'Phone & Cup Mount',
        'Phone and Cup Mount'
      ],
      titles: {
        en: 'Strutt ev¹ Phone & Cup Mount',
        de: 'Strutt ev¹ Handy- und Becherhalter',
        fr: 'Support téléphone et gobelet Strutt ev¹',
        it: 'Supporto telefono e bicchiere Strutt ev¹',
        nl: 'Strutt ev¹ telefoon- en bekerhouder',
        es: 'Soporte para teléfono y vaso Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 手机杯架支架',
        'zh-TW': 'Strutt ev¹ 手機杯架支架',
        ja: 'Strutt ev¹ スマホ＆カップマウント',
        ko: 'Strutt ev¹ 휴대폰 및 컵 마운트',
        th: 'ที่ยึดโทรศัพท์และแก้ว Strutt ev¹'
      }
    },
    smart_push_handle: {
      aliases: [
        'Strutt ev¹ Smart Push Handle',
        'Strutt ev1 Smart Push Handle',
        'Smart Push Handle'
      ],
      titles: {
        en: 'Strutt ev¹ Smart Push Handle',
        de: 'Strutt ev¹ Smart-Schiebegriff',
        fr: 'Poignée de poussée intelligente Strutt ev¹',
        it: 'Maniglia di spinta intelligente Strutt ev¹',
        nl: 'Strutt ev¹ slimme duwhandgreep',
        es: 'Manillar de empuje inteligente Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 智能助推手柄',
        'zh-TW': 'Strutt ev¹ 智慧助推把手',
        ja: 'Strutt ev¹ スマートプッシュハンドル',
        ko: 'Strutt ev¹ 스마트 푸시 핸들',
        th: 'ด้ามเข็นอัจฉริยะ Strutt ev¹'
      }
    },
    pre_order_deposit: {
      aliases: [
        'Strutt ev¹ Pre-Order Deposit',
        'Strutt ev1 Pre-Order Deposit',
        'Pre-Order Deposit'
      ],
      titles: {
        en: 'Strutt ev¹ Pre-Order Deposit',
        de: 'Strutt ev¹ Vorbestellungsanzahlung',
        fr: 'Acompte de précommande Strutt ev¹',
        it: 'Deposito preordine Strutt ev¹',
        nl: 'Strutt ev¹ vooruitbestellingsaanbetaling',
        es: 'Depósito de preventa Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 预订定金',
        'zh-TW': 'Strutt ev¹ 預訂訂金',
        ja: 'Strutt ev¹ 予約金',
        ko: 'Strutt ev¹ 사전 주문 보증금',
        th: 'เงินมัดจำพรีออเดอร์ Strutt ev¹'
      }
    },
    refundable_deposit: {
      aliases: [
        'Strutt ev¹ deposit - refundable',
        'Strutt ev1 deposit - refundable',
        'Refundable Deposit'
      ],
      titles: {
        en: 'Strutt ev¹ Refundable Deposit',
        de: 'Strutt ev¹ erstattungsfähige Anzahlung',
        fr: 'Acompte remboursable Strutt ev¹',
        it: 'Deposito rimborsabile Strutt ev¹',
        nl: 'Strutt ev¹ restitueerbare aanbetaling',
        es: 'Depósito reembolsable Strutt ev¹',
        'zh-CN': 'Strutt ev¹ 可退定金',
        'zh-TW': 'Strutt ev¹ 可退還訂金',
        ja: 'Strutt ev¹ 返金可能なデポジット',
        ko: 'Strutt ev¹ 환불 가능 보증금',
        th: 'เงินมัดจำที่ขอคืนได้ Strutt ev¹'
      }
    },
    ev1: {
      aliases: [
        'Strutt ev¹ -Smart Everyday Vehicle',
        'Strutt ev1 -Smart Everyday Vehicle',
        'Strutt ev¹'
      ],
      titles: {
        en: 'Strutt ev¹',
        de: 'Strutt ev¹',
        fr: 'Strutt ev¹',
        it: 'Strutt ev¹',
        nl: 'Strutt ev¹',
        es: 'Strutt ev¹',
        'zh-CN': 'Strutt ev¹',
        'zh-TW': 'Strutt ev¹',
        ja: 'Strutt ev¹',
        ko: 'Strutt ev¹',
        th: 'Strutt ev¹'
      }
    },
    ev1c: {
      aliases: [
        'Strutt ev¹c -Smart Everyday Vehicle',
        'Strutt ev1c -Smart Everyday Vehicle',
        'Strutt ev¹c'
      ],
      titles: {
        en: 'Strutt ev¹c',
        de: 'Strutt ev¹c',
        fr: 'Strutt ev¹c',
        it: 'Strutt ev¹c',
        nl: 'Strutt ev¹c',
        es: 'Strutt ev¹c',
        'zh-CN': 'Strutt ev¹c',
        'zh-TW': 'Strutt ev¹c',
        ja: 'Strutt ev¹c',
        ko: 'Strutt ev¹c',
        th: 'Strutt ev¹c'
      }
    },
    co_designer_rewards: {
      aliases: [
        'co-designer-rewards',
        'Co-designer rewards',
        'Co-Designer Rewards'
      ],
      titles: {
        en: 'Co-designer Rewards',
        de: 'Co-Designer Rewards',
        fr: 'Récompenses co-designer',
        it: 'Ricompense co-designer',
        nl: 'Co-designer-beloningen',
        es: 'Recompensas co-designer',
        'zh-CN': '共创奖励',
        'zh-TW': '共創獎勵',
        ja: '共同デザイナー特典',
        ko: '공동 디자이너 리워드',
        th: 'รางวัล Co-designer'
      }
    }
  };

  function normalizeTitle(title) {
    return String(title || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function normalizeLocale(locale) {
    const rawLocale = String(
      locale ||
      (window.Shopify && window.Shopify.locale) ||
      (document.documentElement && document.documentElement.lang) ||
      'en'
    ).trim();
    const lowerLocale = rawLocale.toLowerCase();

    if (lowerLocale === 'zh-cn') return 'zh-CN';
    if (lowerLocale === 'zh-tw') return 'zh-TW';
    if (lowerLocale.startsWith('en')) return 'en';
    if (lowerLocale.startsWith('de')) return 'de';
    if (lowerLocale.startsWith('fr')) return 'fr';
    if (lowerLocale.startsWith('it')) return 'it';
    if (lowerLocale.startsWith('nl')) return 'nl';
    if (lowerLocale.startsWith('es')) return 'es';
    if (lowerLocale.startsWith('ja')) return 'ja';
    if (lowerLocale.startsWith('ko')) return 'ko';
    if (lowerLocale.startsWith('th')) return 'th';

    return rawLocale;
  }

  function getMatchedEntry(rawTitle) {
    const normalizedTitle = normalizeTitle(rawTitle);
    if (!normalizedTitle) return null;

    for (const [key, config] of Object.entries(productTitleMap)) {
      const aliases = Array.isArray(config.aliases) ? config.aliases : [];
      const matched = aliases.some((alias) => normalizeTitle(alias) === normalizedTitle);
      if (matched) {
        return { key, config };
      }
    }

    return null;
  }

  function getLocalizedTitle(rawTitle, locale) {
    const matchedEntry = getMatchedEntry(rawTitle);
    if (!matchedEntry) return '';

    const normalizedLocale = normalizeLocale(locale);
    const titles = matchedEntry.config.titles || {};

    return titles[normalizedLocale] || titles.en || '';
  }

  function getMatchedProductKey(rawTitle) {
    const matchedEntry = getMatchedEntry(rawTitle);
    return matchedEntry ? matchedEntry.key : '';
  }

  window.orderProductTitleMap = {
    products: productTitleMap,
    normalizeTitle: normalizeTitle,
    normalizeLocale: normalizeLocale,
    getMatchedEntry: getMatchedEntry,
    getMatchedProductKey: getMatchedProductKey,
    getLocalizedTitle: getLocalizedTitle
  };
})();
